export default __webpack_public_path__ + "static/media/ic-animals-defol.62e76045.svg";